module.exports = __webpack_public_path__ + "static/media/IMG_7043.33aceca3.jpg";